module.exports = __webpack_public_path__ + "media/fonts/Roboto-Italic-2a1b89d7506c26fb931b47bbc5d8c926.ttf";